import React, { useState } from 'react';
import { useToast } from '../hooks/use-toast';
import { Toaster } from './ui/toaster';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const submit = (e) => {
    e.preventDefault();
    if (!email.includes('@')) {
      toast({ title: 'Please enter a valid email', variant: 'destructive' });
      return;
    }
    toast({ title: 'Subscribed!', description: 'You will receive our latest updates.' });
    setEmail('');
  };

  return (
    <section className="w-full bg-[#7a1a2a] text-white py-14 px-6 md:px-10">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <div className="text-[11px] tracking-[0.4em] uppercase text-[#e6c98f] mb-2">Newsletter</div>
          <h3 className="serif text-3xl md:text-4xl font-light">Find Out First</h3>
          <p className="text-sm opacity-90 mt-1">Get emails of the latest news about products, events and more!</p>
        </div>
        <form onSubmit={submit} className="flex items-center w-full md:w-auto border-b border-white/40 focus-within:border-white transition-colors">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="bg-transparent outline-none py-3 pr-4 placeholder-white/60 text-white min-w-[260px]"
          />
          <button type="submit" className="text-[11px] tracking-[0.3em] uppercase px-2 py-3 hover:text-[#e6c98f] transition-colors">Subscribe</button>
        </form>
      </div>
      <Toaster />
    </section>
  );
}
